import { createSelector } from '@reduxjs/toolkit';

import { calculateMemberGeometry } from '@paragon/relative-geometry';
import { notNullish } from '@paragon/utilities';

import { RootState } from '../store';
import { getLoadedTrussesByAnalysisSetGuid } from './trusses';

export const getMemberVertices = createSelector(
  getLoadedTrussesByAnalysisSetGuid,
  (state: RootState, analysisSetGuid: string) => analysisSetGuid,

  (loadedTrussesByAnalysisSetGuid, analysisSetGuid) => {
    const truss = loadedTrussesByAnalysisSetGuid[analysisSetGuid];
    if (!truss) return null;
    return truss.members.map((member) => calculateMemberGeometry(member, truss)).filter(notNullish);
  },
);
